



import SetupSidebar from '@/components/setup/SetupSidebar.vue'

export default {
    components: { SetupSidebar },
    name: 'index',
    middleware: 'userAuth',//中间件页面登录鉴权
    data() {
        return {
            url: 'https://community.xp-pen.com/'
        };
    },
    methods: {
        onCopy() {
            this.$copyText(this.url).then(
                e => {
                    console.log('复制成功：', e);
                },
                e => {
                    console.log('复制失败：', e);
                }
            )
        }
    }

}
